module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_7016.ce24865b.png";